import React, { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Index from "./pages/Index";
import Services from "./pages/managed-services/Services";
import ServiceDetails from "./pages/managed-services/ServiceDetails";
import Community from "./pages/Community";
import Events from "./pages/events/Events";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Blog from "./pages/blogs/Blog";
import BlogDetail from "./pages/blogs/BlogDetails";
import BlogCategories from "./pages/blogs/BlogCategories";
import EventDetailPage from "./pages/events/EventDetails";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AboutUs from "./pages/AboutUs";
import ScrollToTop from "./components/ScrollToTop";
import PageTitle from "./components/PageTitle";
import "./App.css";

const queryClient = new QueryClient();

const App = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            {isMounted && (
              <BrowserRouter>
                <ScrollToTop />
                <PageTitle />
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:serviceId" element={<ServiceDetails />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:eventId" element={<EventDetailPage />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/categories" element={<BlogCategories />} />
                  <Route path="/blog/:blogId" element={<BlogDetail />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
            )}
          </TooltipProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

export default App;
